import { useEffect, useState } from "react";

/**
 * A boolean that mirrors `active` but turns true only after `active` has stayed
 * true continuously for `delayMs`, and falls straight back to false the instant
 * `active` goes false.
 *
 * Used to grace-gate a transient UI flag so a state that resolves within the
 * delay never flashes on screen. On the Logs tab it gates the "Showing N so far,
 * scanning older…" footer: a fast gradual load (the common case, especially the
 * early prefetch) finishes inside the grace window, so the message is never shown
 * (Stefan, 2026-10-14). See operator-task-fe-logs-tab-bounded-dom-virtualization.
 */
export function useDelayedTrue(active: boolean, delayMs: number): boolean {
    const [elapsed, setElapsed] = useState(false);
    useEffect(() => {
        if (!active) {
            setElapsed(false);
            return undefined;
        }
        const handle = window.setTimeout(() => setElapsed(true), delayMs);
        return () => window.clearTimeout(handle);
    }, [active, delayMs]);
    return elapsed;
}

export default useDelayedTrue;
